<template>
    <div class="cities">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label for="">İl Ara</label>
                    <input type="text" v-model="search" class="form-control custom-input" placeholder="ör: Adana">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="widget">
                    <div class="table-area">
                        <div class="widget-title">
                            <h3><i :class="icon"> </i> {{ tableName }}</h3>
                            <span>{{ tableDesc }}</span>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>İl</th>
                                        <th>İşlemler</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in filteredList" :key="item.id">
                                        <td>{{ item.name }}</td>
                                        <td>
                                            <router-link :to="{ name: 'cities.update', params: {id: item.id} }" class="btn btn-primary btn-xs"> <span>Düzenle</span></router-link> / <button class="btn btn-danger btn-xs">Sil</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                icon: 'fa fa-bank',
                tableName: 'İller Tablosu',
                tableDesc: 'Bu tablo sitenizde aktif/pasif olan İlleri gösterir',
                api: 'cities',
                items: [],
                search: '',
            }
        },
        created () {
            this.getData()
        },
        methods: {
            getData() {
                this.axios.get(this.api)
                    .then(response => {
                        this.items = response.data
                    })
            },
        },
        computed: {
            filteredList() {
                return this.items.filter(item => {
                    return item.name.toLowerCase().includes(this.search.toLowerCase())
                }) 
            }
        },
    }
</script>

<style scoped>

</style>